import { gql } from "@apollo/client";

export const GET_DSP_ADJUST_BILL_CSV_DOWNLOAD_URL = gql`
  query GetDspAdjustBillCsvDownloadUrl($taskId: ID!) {
    getDspAdjustBillCsvDownloadUrl(taskId: $taskId)
  }
`;

export interface GetDspAdjustBillCsvDownloadUrlData {
  getDspAdjustBillCsvDownloadUrl: string;
}

export interface GetDspAdjustBillCsvDownloadUrlVariables {
  taskId: number;
}
